import type { PropsWithChildren } from "react";

import { AlertBanner } from "@similarweb/ui-components";

const ErrorBanner = ({ children }: PropsWithChildren) => {
    return (
        <AlertBanner
            variant="error"
            data-automation="crm-enrichment-error-banner"
        >
            <AlertBanner.Description>{children}</AlertBanner.Description>
        </AlertBanner>
    );
};

export default ErrorBanner;
